import { Typography } from '@carto/meridian-ds/components'
import { FormattedMessage } from 'react-intl'
import JobsImportingTab from './JobsImportingTab'
import JobsProcessingTab from './JobsProcessingTab'
import JobsExportingTab from './JobsExportingTab'
import settings from 'settings'
import { JobsPopperTab } from 'features/jobs/types'
import useUserPermissions from 'features/account/state/useUserPermissions'

interface JobsTabsProps {
  selectedTab: JobsPopperTab
}

function JobsTabs({ selectedTab }: JobsTabsProps) {
  const { exportViewportDataAvailable } = useUserPermissions()
  const showExportsTab = settings.enableExports || exportViewportDataAvailable

  return (
    <>
      {selectedTab === JobsPopperTab.Processing ? (
        <JobsProcessingTab />
      ) : selectedTab === JobsPopperTab.Imports ? (
        <Typography variant="subtitle1">
          <JobsImportingTab />
        </Typography>
      ) : showExportsTab && selectedTab === JobsPopperTab.Exports ? (
        <Typography variant="subtitle1">
          <JobsExportingTab />
        </Typography>
      ) : (
        <Typography variant="subtitle1">
          <FormattedMessage id="jobs.tabs.na" />
        </Typography>
      )}
    </>
  )
}

export default JobsTabs
